import React from 'react';
import {Home, About, Services, Products, Menu, Contact, Gallery} from '../../sections'; 
import { Counter } from '../../components';

 
const HomePage = () => { 
  return ( 
      <div className='homepage'>
        <Home />
        <About />
        <Services />
        <Menu />
        <Gallery />
        <Products /> 
        <Counter />
        <Contact />
      </div>
  )
}

export default HomePage;
